import { Select as AntSelect, SelectProps } from 'antd';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ active?: boolean }>`
  border: 1px solid ${(props) => (props.active ? '#0046FF' : 'rgba(0, 0, 0, 0.15)')};
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const TopBar = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 16px;

  background: #f7f7f7;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px 4px 0 0;
`;

export const TopBarLeft = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const BlockEventName = styled.div<{ active?: boolean }>`
  letter-spacing: -0.01em;
  color: ${(props) => (props.active ? '#0046FF' : 'rgba(0, 0, 0, 0.88)')};
`;

interface ICusSelect extends SelectProps {
  active?: boolean;
}

export const CusSelect = styled(AntSelect)<ICusSelect>`
  &&.emp-ant-select {
    color: rgba(0, 0, 0, 0.85);

    .emp-ant-select-selector {
      height: 28px;
      border-radius: 3px;
      border: solid 1px transparent;
      background-color: transparent;

      ${(props) => {
        if (props?.active) {
          return css`
            background-color: #e6edff;
            border: solid 1px rgba(0, 0, 0, 0.15);
            color: #0046ff;
          `;
        }
      }}
      &:hover {
        border: solid 1px rgba(0, 0, 0, 0.15);
      }

      .emp-ant-select-selection-item {
        font-weight: 500;
        letter-spacing: -0.01em;
        line-height: 26px;
      }

      .emp-ant-select-selection-search-input {
        height: 26px;
      }

      .emp-ant-select-selection-placeholder {
        line-height: 26px;
      }
    }

    .emp-ant-select-item-option {
      padding: 0;
      height: 32px;
      display: flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.65);
      letter-spacing: -0.01em;
      font-weight: 400;
    }

    .emp-ant-select-item-option-selected:not(.emp-ant-select-item-option-disabled) {
      background: #e6edff;
    }

    .emp-ant-select-item-option-content {
      line-height: 20px;
    }
  }

  &&.emp-ant-select-disabled.emp-ant-select:not(.emp-ant-select-customize-input)
    .emp-ant-select-selector {
    color: rgba(0, 0, 0, 0.45);
  }
`;
